import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircleIcon } from '@heroicons/react/20/solid';

export interface StepItem {
    label: React.ReactNode;
    /** A dashboard route; only set where the viewer is signed in. */
    to?: string;
    done?: boolean;
}

// #region StepList
/** Numbered steps with coral brand numerals. Done steps get a tick; steps with a route become links. */
export const StepList: React.FunctionComponent<{ steps: StepItem[] }> = ({ steps }): React.ReactElement => (
    <ol className="space-y-2.5 text-sm text-zinc-700 dark:text-zinc-300">
        {steps.map((step, i) => (
            <li key={i} className="flex items-start gap-2.5">
                {step.done
                    ? <CheckCircleIcon className="mt-px h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400" aria-label="Done" />
                    : <span className="mt-px inline-flex h-5 w-6 shrink-0 items-center font-display text-sm font-semibold tabular-nums text-brand">{String(i + 1).padStart(2, '0')}</span>}
                {step.done ? (
                    <span className="text-zinc-500 line-through decoration-zinc-400 dark:text-zinc-400">{step.label}</span>
                ) : step.to ? (
                    <Link to={step.to} className="group inline-flex items-center gap-1 font-medium text-zinc-800 underline decoration-zinc-300 underline-offset-4 hover:text-blue-700 hover:decoration-blue-600 dark:text-zinc-200 dark:decoration-zinc-600 dark:hover:text-blue-400">
                        {step.label}
                        <ArrowRightIcon className="h-4 w-4 opacity-0 transition group-hover:translate-x-0.5 group-hover:opacity-100" aria-hidden />
                    </Link>
                ) : (
                    <span>{step.label}</span>
                )}
            </li>
        ))}
    </ol>
);
